export default {
  refreshCriteria: 'isolationAging.refreshCriteria',
};
